'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var sumBy = require('./sumBy.js');
function meanBy(items, getValue) {
    return sumBy.sumBy(items, function(item) {
        return getValue(item);
    }) / items.length;
}
exports.meanBy = meanBy;
